import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { IconPlusCircleWhite } from '../../assets/icons'
import emptyRegisteredVehicleImage from '../../assets/images/quanlydangki_khongcoxe.png'
import networkErrorImage from '../../assets/images/quanlydangki_loimang.png'
import BaseButton from '../../components/BasicComponent/BaseButton'
import BottomBar from '../../components/BasicComponent/BottomBar'
import HomeBannerCache from '../../components/BasicComponent/HomeBannerCache'
import LoadingScreen from '../../components/BasicComponent/LoadingScreen'
import SafeImage from '../../components/BasicComponent/SafeImage'
import VehicleItem from '../../components/BasicComponent/VehicleItem'
import VehicleItemSkeletonList from '../../components/BasicComponent/VehicleItemSkeletonList'
import { PATH } from '../../constants/router'
import { useAppUserContext } from '../../context/AppUserContext'
import { useTrafficFineVehicleContext } from '../../context/TrafficFineVehicleContext'
import useLoadHomeCache from '../../hooks/common/useLoadHomeCache'
import useRefreshTrafficFineVehicleListOnRouteEnter from '../../hooks/common/useRefreshTrafficFineVehicleListOnRouteEnter'
import HeaderPartner from '../../components/BasicComponent/HeaderPartner'
import LayoutPartner from '../../components/BasicComponent/LayoutPartner'
import './index.scss'

export default function TrafficFineRegistrationManagement() {
  const history = useHistory()
  const { homeBanners, homeCacheLoading } = useLoadHomeCache()
  const { userData } = useAppUserContext()
  const { listVehicleRegisteredPackage, isLoadingVehicleList, isVehicleListNetworkError, getVehicleLists } = useTrafficFineVehicleContext()
  const registeredVehicles = listVehicleRegisteredPackage
  const hasRegisteredVehicles = registeredVehicles.length > 0
  const [shouldShowEmptyState, setShouldShowEmptyState] = useState(false)

  useRefreshTrafficFineVehicleListOnRouteEnter({
    isLoading: isLoadingVehicleList,
    refreshVehicleList: getVehicleLists
  })

  useEffect(() => {
    if (hasRegisteredVehicles || isLoadingVehicleList || isVehicleListNetworkError) {
      setShouldShowEmptyState(false)
      return
    }

    const timeoutId = window.setTimeout(() => {
      setShouldShowEmptyState(true)
    }, 0)

    return () => {
      window.clearTimeout(timeoutId)
    }
  }, [hasRegisteredVehicles, isLoadingVehicleList, isVehicleListNetworkError])

  const openServicesPage = () => {
    history.push({
      pathname: PATH.TRAFFIC_FINE_SERVICES,
      state: {
        phoneNumber: userData?.phoneNumberWithUsernamePrefix
      }
    })
  }

  const goToPackageInfo = (vehicle) => {
    history.push({
      pathname: PATH.TRAFFIC_FINE_PACKAGE_INFO,
      state: {
        vehicleIdentity: vehicle?.vehicleIdentity,
        vehicleType: vehicle?.vehicleType,
        vehicleActivePackage: vehicle
      }
    })
  }

  const handleRetryLoadVehicles = () => {
    void getVehicleLists()
  }

  const showNetworkError = isVehicleListNetworkError && !isLoadingVehicleList && !hasRegisteredVehicles

  const bottomBarTopContent = showNetworkError ? (
    <div className="TrafficFineRegistrationManagement_bottomAction">
      <BaseButton onClick={handleRetryLoadVehicles}>Thử lại</BaseButton>
    </div>
  ) : shouldShowEmptyState ? (
    <div className="TrafficFineRegistrationManagement_bottomAction">
      <BaseButton onClick={openServicesPage}>Đăng ký ngay</BaseButton>
    </div>
  ) : null

  return (
    <LayoutPartner>
      <HeaderPartner title="Quản lý đăng ký" />

      <div className="TrafficFineRegistrationManagement">
        {isLoadingVehicleList ? (
          <div className="TrafficFineRegistrationManagement_list">
            <VehicleItemSkeletonList itemKeyPrefix="traffic-fine-registration-management-skeleton" />
          </div>
        ) : showNetworkError ? (
          <div className="TrafficFineRegistrationManagement_empty">
            <SafeImage src={networkErrorImage} className="TrafficFineRegistrationManagement_emptyImage" />

            <div className="TrafficFineRegistrationManagement_emptyTitle">Không thể tải danh sách xe</div>
            <div className="TrafficFineRegistrationManagement_emptyDescription">Vui lòng kiểm tra kết nối mạng và thử lại</div>
          </div>
        ) : hasRegisteredVehicles ? (
          <>
            <div className="TrafficFineRegistrationManagement_header">
              <div className="TrafficFineRegistrationManagement_headerContent">
                <div className="TrafficFineRegistrationManagement_headerTitle">Xe đã đăng ký ({registeredVehicles.length})</div>
                <div className="TrafficFineRegistrationManagement_headerDescription">Tự động thông báo lỗi phạt 2 tuần một lần</div>
              </div>

              <button type="button" className="TrafficFineRegistrationManagement_addButton" onClick={openServicesPage}>
                <span>Thêm xe</span>
                <IconPlusCircleWhite className="TrafficFineRegistrationManagement_addButtonIcon" />
              </button>
            </div>

            <div className="TrafficFineRegistrationManagement_list">
              {registeredVehicles.map((vehicle, index) => (
                <VehicleItem
                  key={vehicle?.appUserVehicleNotifyInfoId || `${vehicle?.vehicleIdentity}-${vehicle?.vehicleType}-${index}`}
                  vehicleIdentity={vehicle?.vehicleIdentity}
                  vehicleType={vehicle?.vehicleType}
                  isRegisteredPackage
                  registeredPackageMode={2}
                  notifyEndDateTime={vehicle?.notifyEndDateTime}
                  allowRenew={vehicle?.allowRenew}
                  onClick={() => {}}
                  onClickArrowRight={() => goToPackageInfo(vehicle)}
                  onActionClick={() => goToPackageInfo(vehicle)}
                />
              ))}
            </div>

            <HomeBannerCache promoBanners={homeBanners} loading={homeCacheLoading} />
          </>
        ) : shouldShowEmptyState ? (
          <div className="TrafficFineRegistrationManagement_empty">
            <SafeImage src={emptyRegisteredVehicleImage} className="TrafficFineRegistrationManagement_emptyImage" />

            <div className="TrafficFineRegistrationManagement_emptyTitle">Bạn chưa có xe nào được đăng ký</div>
            <div className="TrafficFineRegistrationManagement_emptyDescription">
              Vui lòng thêm xe để theo dõi tự động và nhận thông báo vi phạm kịp thời qua tin nhắn SMS
            </div>
          </div>
        ) : null}
      </div>

      <BottomBar elementPaddingBottom="LayoutPartner" tabActive={2} topContent={bottomBarTopContent} onLookupClick={() => history.goBack()} />
      <LoadingScreen open={isLoadingVehicleList} />
    </LayoutPartner>
  )
}
